import axios from 'axios';

export const fetchTotalPostagens = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/data/posts/search`, {
      params: {
        intervaloDatas: '{}', 
        periodoDia: '',
        diasSemana: '',
        filtroTexto: '',
        campoTexto: ''
      }
    });



    if (response.data && response.data.length > 0) {
      const allPosts = response.data;
      const allSortedPosts = [...allPosts].sort((a, b) => new Date(a._source.data_postagem) - new Date(b._source.data_postagem));

      return {
        dataInicioTotal: new Date(allSortedPosts[0]._source.data_postagem).toISOString().split('T')[0],
        dataFimTotal: new Date(allSortedPosts[allSortedPosts.length - 1]._source.data_postagem).toISOString().split('T')[0]
      };
    }
  } catch (error) {
    console.error('Erro ao buscar postagens totais:', error);
    throw error;
  }
};

export const fetchPostagens = async (params) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/data/posts/search`, { params });
    return response.data || [];
  } catch (error) {
    console.error('Erro ao buscar dados:', error);
    throw error;
  }
};
